import * as React from 'react';

import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';

import { SheetCellMenuOptions } from '../../../admin/constants/SheetCellMenuOptions';
import { ReactComponent as DeleteIcon } from '../../../common/assets/icons/delete_icon_red_small.svg';
import { ReactComponent as EditIcon } from '../../../common/assets/icons/edit_icon_gray_small.svg';
import StyledPopover from '../../../common/components/StyledPopover';

type Props = {
  handleClose: () => void;
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  id?: string;
  handleSelectedItem: (item: SheetCellMenuOptions) => void;
};

const SheetCellPopupMenu: React.FC<Props> = ({
  handleClose,
  anchorEl,
  handleSelectedItem,
  open,
  id,
}) => {
  return (
    <StyledPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      id={id}
    >
      <MenuList>
        <MenuItem
          divider
          onClick={() => handleSelectedItem(SheetCellMenuOptions.Rename)}
        >
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <Typography color='appGray2.main'>
            {SheetCellMenuOptions.Rename}
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => handleSelectedItem(SheetCellMenuOptions.Delete)}
        >
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <Typography color='error'>{SheetCellMenuOptions.Delete}</Typography>
        </MenuItem>
      </MenuList>
    </StyledPopover>
  );
};

export default SheetCellPopupMenu;
